import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/services';
import { AnalyticsService } from 'src/services/analytics.service';

declare var $: any;

@Component({
  selector: 'app-new-login',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './new-login.component.html',
  styleUrls: ['./new-login.component.scss']
})
export class NewLoginComponent implements OnInit {
  loginForm!: FormGroup;
  forgetPwForm!: FormGroup;
  getEmailForm!: FormGroup;
  trackingForm!: FormGroup;
  isPasswordVisible = false;
  isGetOtp = false;
  user: any;
  containersData: any[] = [];
  viewAllMap = false;
  containerNo: string = '';
  cfs: string = '';
  authentic = null;
  constructor(
    private analyticsService: AnalyticsService,
    private formBuilder: FormBuilder,
    private router: Router,
    private service: AuthService
  ) {
    this.checkLogin();
  }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
    });

    this.forgetPwForm = this.formBuilder.group({
      otp: ['', Validators.required],
      newPassword: ['', [
        Validators.required,
        Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,}$)/)
      ]],
    });

    this.getEmailForm = this.formBuilder.group({
      email: ['', Validators.required],
    });

    this.createTrackingForm();
  }

  createTrackingForm(): void {
    this.trackingForm = this.formBuilder.group({
      baseForm: this.formBuilder.array([this.createItem()]),
      cfs: ['', Validators.required],
    });
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      container: ['', Validators.compose([Validators.required, Validators.pattern(/^([a-zA-Z]{4})([0-9]{7})$/)])],
    });
  }

  get baseForm(): FormArray {
    return this.trackingForm.get('baseForm') as FormArray;
  }

  addItem(): void {
    this.baseForm.push(this.createItem());
  }

  deleteRow(index: number): void {
    const control = this.trackingForm.controls['baseForm'] as FormArray;
    control.removeAt(index);
  }

  login(): void {
    this.authentic = null;
    this.analyticsService.trackEvent('click', 'user_interaction', 'login_click');
    const { password, email } = this.loginForm.value;
    this.service.login({ password, email, type: 'app' }).subscribe((res: any) => {
      const { success, token, data, message, sso, sessionKey } = res;
      if (success) {
        this.authentic = true;
        setTimeout(() => {
          localStorage.setItem(environment.auth_token, token);
          localStorage.setItem('user', JSON.stringify(data));
          if (sso) {
            localStorage.setItem(environment.sso_token, sso.token);
            localStorage.setItem('sso_details', JSON.stringify(sso));
          }
          if (sessionKey) {
            localStorage.setItem('sessionKey', sessionKey);
          }
          if (data.theme) {
            localStorage.setItem('theme', data.theme);
          }
          // Single redirect — no router.navigate + reload combo
          const targetRoute = data?.homePage ? `/${data.homePage}` : '/container';
          window.location.href = targetRoute;
        }, 1000);
      } 
      else 
      {
        this.authentic = false;
        this.service.showToast('error', message);
      }
    }, this.service.error);
  }

  private route(): void {
    const user = localStorage.getItem('user') && JSON.parse(localStorage.getItem('user') || '{}');
    const targetRoute = user?.homePage ? `/${user.homePage}` : '/container';
    this.router.navigate([targetRoute]);
  }

  checkLogin(): void {
    if (localStorage.getItem(environment.auth_token) && localStorage.getItem('user')) {
      this.route();
    }
  }

  togglePasswordVisibility(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  getOTP(): void {
    this.service.forgetPassword({ email: this.getEmailForm.value.email }).subscribe((res: any) => {
      const { success, message } = res;
      if (success) {
        this.isGetOtp = true;
        this.service.showToast('success', message);
      } else {
        this.service.showToast('error', message);
      }
    }, this.service.error);
  }

  forgetPassword(): void {
    const obj = {
      otp: this.forgetPwForm.value.otp,
      password: this.forgetPwForm.value.newPassword,
      email: this.getEmailForm.value.email,
    };
    this.service.setNewPasswordSSO(obj).subscribe((res: any) => {
      if (res.success) {
        $('#forgetModal').modal('hide');
        this.isGetOtp = false;
        this.service.showToast('success', res.message);
        this.getEmailForm.reset();
        this.forgetPwForm.reset();
      } else {
        this.service.showToast('error', res.message);
      }
    });
  }

  closeForgetModal(): void {
    this.isGetOtp = false;
    this.getEmailForm.reset();
    this.forgetPwForm.reset();
  }

  restrictNumeric(e: KeyboardEvent): boolean {
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32 || e.which === 46) {
      return false;
    }
    if (e.which === 0 || e.which < 33) {
      return true;
    }
    const input = String.fromCharCode(e.which);
    return !!/[\d\.\s]/.test(input);
  }

  trackEvent(id: string): void {
    this.analyticsService.trackEvent('click', 'user_interaction', id);
  }

  trackContainer(): void {
    this.viewAllMap = false;
    const containers: string[] = [];
    this.trackingForm.value.baseForm.map((item: any) => {
      containers.push(item.container.toUpperCase());
    });

    this.containersData = [];
    this.service.trackContainer({ containerNo: containers, cfs: this.trackingForm.value.cfs }).subscribe((res: any) => {
      const { success, message, data } = res;
      if (success) {
        if (data.length == 1 && data[0].containerDetails.actionType == 'anotherYard') {
          this.service.showToast('error', 'Container Shifted to Other Yard');
          return;
        }

        const shiftedConts: string[] = [];

        data.map((item: any) => {
          if (item.containerDetails.actionType != 'anotherYard') {
            if (item.lastStatus == 'picked') {
              this.viewAllMap = true;
              item.loc = item.moves[0].positionDetails.time[item.movesCount].picked.properties.name;
              if (item.moves[0].positionDetails.time[item.movesCount].picked.properties.newName) {
                item.loc = item.moves[0].positionDetails.time[item.movesCount].picked.properties.newName;
              }
              item.time = item.moves[0].positionDetails.time[item.movesCount].start;
            } else if (item.lastStatus == 'stacked') {
              this.viewAllMap = true;
              item.loc = item.moves[0].positionDetails.time[item.movesCount].stacked.properties.name;
              if (item.moves[0].positionDetails.time[item.movesCount].stacked.properties.newName) {
                item.loc = item.moves[0].positionDetails.time[item.movesCount].stacked.properties.newName;
              }
              item.time = item.moves[0].positionDetails.time[item.movesCount].end;
            }
            this.containersData.push(item);
          } else {
            shiftedConts.push(item.containerDetails.container);
          }
        });

        if (shiftedConts.length != 0) {
          this.service.showToast('error', shiftedConts.toString() + ' Container Shifted to Other Yard');
        }
      } else {
        this.service.showToast('error', message);
      }
    }, this.service.error);
  }

  goToMap(id: string): void {
    const data = this.containersData.filter(item => item._id == id);
    localStorage.setItem(id, JSON.stringify(data[0]));
    window.open(window.location.origin + '/trackmap?id=' + id + '&cfs=' + this.trackingForm.value.cfs, '_blank');
  }

  multiMap(): void {
    const containers: string[] = [];
    this.trackingForm.value.baseForm.map((item: any) => {
      containers.push(item.container.toUpperCase());
    });
    localStorage.setItem('multi', JSON.stringify(containers));
    window.open(window.location.origin + '/trackmap?id=multi&cfs=' + this.trackingForm.value.cfs, '_blank');
  }

  resetContainer(): void {
    this.containersData = [];
    this.containerNo = '';
    this.cfs = '';
    this.createTrackingForm();
  }
}
